export const getRowsPerPageOptions = (totalItems = 0, step = 12) => {
  const total = Number(totalItems) || 0;

  if (total <= step) {
    return [step];
  }

  const options = [];
  for (let value = step; value < total; value += step) {
    options.push(value);
  }

  if (options[options.length - 1] !== total) {
    options.push(total);
  }

  return options;
};

export const getPaginationTotal = (pagination, fallback = 0) =>
  pagination?.total_items ??
  pagination?.total ??
  pagination?.total_count ??
  pagination?.count ??
  fallback;
